import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { addProduct, changeQuantity, cartTotals, sameVariant } from './cartUtils';
const CartContext = React.createContext();
function newCheckout() { try { sessionStorage.removeItem('sib-checkout-cash'); } catch {} }
function readCart() {
  try {
    const items = JSON.parse(localStorage.getItem('productosAgregados') || '[]');
    return Array.isArray(items) ? items.filter(item => item && Number.isInteger(item.cantidad)
      && item.cantidad > 0 && Number.isFinite(Number(item.precioProd))) : [];
  } catch { return []; }
}
const ItemsProvider = ({ children }) => {
  const [productosAgregados, setProductos] = useState(readCart);
  const [preferenceId, setPreferenceId] = useState(null);
  const { precioTotal, totalItems } = useMemo(() => cartTotals(productosAgregados), [productosAgregados]);
  const addItemToCart = useCallback(product => { newCheckout(); setProductos(items => addProduct(items, product)); }, []);
  const moreItemsOnCart = useCallback((id, amount, colorProd, talleProd) => {
    newCheckout();
    setProductos(items => changeQuantity(items, { id, colorProd, talleProd }, Number(amount)));
  }, []);
  const lessItemsOnCart = useCallback((id, amount, colorProd, talleProd) => {
    newCheckout();
    setProductos(items => changeQuantity(items, { id, colorProd, talleProd }, -Number(amount)));
  }, []);
  const removeItemFromCart = useCallback(product => { newCheckout(); setProductos(items => items.filter(item => !sameVariant(item, product))); }, []);
  const clearAllItems = useCallback(() => { newCheckout(); setProductos([]); setPreferenceId(null); }, []);
  useEffect(() => {
    setPreferenceId(null);
    try {
      localStorage.setItem('productosAgregados', JSON.stringify(productosAgregados));
      localStorage.setItem('precioTotal', JSON.stringify(precioTotal));
    } catch { /* The cart remains usable when storage is unavailable. */ }
  }, [productosAgregados, precioTotal]);
  const value = useMemo(() => ({ addItemToCart, removeItemFromCart, clearAllItems, moreItemsOnCart,
    lessItemsOnCart, setPreferenceId, preferenceId, productosAgregados, precioTotal, totalItems }),
  [addItemToCart, removeItemFromCart, clearAllItems, moreItemsOnCart, lessItemsOnCart, preferenceId,
    productosAgregados, precioTotal, totalItems]);
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
export { CartContext, ItemsProvider };
